import React from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Flex,
  Card,
  CardBody,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Icon,
  Progress,
  HStack,
} from '@chakra-ui/react';
import { FiCreditCard, FiDownload, FiAlertCircle } from 'react-icons/fi';

const UserBilling = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const cardBg = useColorModeValue('gray.50', 'gray.700');

  // Dummy billing data - replace with actual data from your backend
  const billingHistory = [
    {
      id: 1,
      date: '2024-03-01',
      amount: '$29.99',
      status: 'Paid',
      plan: 'Premium',
      invoice: 'INV-001',
    },
    {
      id: 2,
      date: '2024-02-01',
      amount: '$29.99',
      status: 'Paid',
      plan: 'Premium',
      invoice: 'INV-002',
    },
  ];

  const currentPlan = {
    name: 'Premium Plan',
    price: '$29.99',
    nextBillingDate: 'April 1, 2024',
    features: ['Unlimited Messages', 'Priority Support', 'Advanced Analytics'],
    usage: 75, // percentage
  };

  return (
    <Box p={5}>
      <VStack spacing={6} align="stretch">
        <Heading size="lg">My Billing</Heading>

        <Flex gap={6} wrap="wrap">
          {/* Current Plan Card */}
          <Card flex="1" minW="300px" bg={cardBg}>
            <CardBody>
              <VStack align="stretch" spacing={4}>
                <HStack justify="space-between">
                  <Heading size="md">Current Plan</Heading>
                  <Badge colorScheme="green" fontSize="sm">Active</Badge>
                </HStack>
                
                <Stat>
                  <StatLabel>Monthly Cost</StatLabel>
                  <StatNumber>{currentPlan.price}</StatNumber>
                  <StatHelpText>Next billing: {currentPlan.nextBillingDate}</StatHelpText>
                </Stat>

                <Box>
                  <Text mb={2}>Plan Usage</Text>
                  <Progress value={currentPlan.usage} colorScheme="purple" borderRadius="full" />
                </Box>

                <VStack align="stretch" spacing={2}>
                  {currentPlan.features.map((feature, index) => (
                    <HStack key={index}>
                      <Icon as={FiCreditCard} color="green.500" />
                      <Text>{feature}</Text>
                    </HStack>
                  ))}
                </VStack>

                <Button colorScheme="purple" size="lg">
                  Upgrade Plan
                </Button>
              </VStack>
            </CardBody>
          </Card>

          {/* Payment Method Card */}
          {/* <Card flex="1" minW="300px" bg={cardBg}>
            <CardBody>
              <VStack align="stretch" spacing={4}>
                <Heading size="md">Payment Method</Heading>
                <HStack p={4} bg={bgColor} borderRadius="md" borderWidth="1px" borderColor={borderColor}>
                  <Icon as={FiCreditCard} boxSize={6} />
                  <VStack align="start" spacing={0}>
                    <Text fontWeight="bold">•••• •••• •••• 4242</Text>
                    <Text fontSize="sm" color="gray.500">Expires 12/25</Text>
                  </VStack>
                </HStack>
                <Button variant="outline" leftIcon={<FiCreditCard />}>
                  Update Payment Method
                </Button>
              </VStack>
            </CardBody>
          </Card> */}
        </Flex>

        {/* Billing History */}
        <Box
          p={6}
          bg={bgColor}
          borderWidth="1px"
          borderColor={borderColor}
          borderRadius="lg"
          shadow="sm"
        >
          <Flex justify="space-between" align="center" mb={4}>
            <Heading size="md">Billing History</Heading>
            <Button leftIcon={<FiDownload />} size="sm">
              Export
            </Button>
          </Flex>
          
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Date</Th>
                <Th>Invoice</Th>
                <Th>Amount</Th>
                <Th>Plan</Th>
                <Th>Status</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {billingHistory.map((bill) => (
                <Tr key={bill.id}>
                  <Td>{bill.date}</Td>
                  <Td>{bill.invoice}</Td>
                  <Td>{bill.amount}</Td>
                  <Td>{bill.plan}</Td>
                  <Td>
                    <Badge colorScheme="green">{bill.status}</Badge>
                  </Td>
                  <Td>
                    <Button size="sm" variant="ghost" leftIcon={<FiDownload />}>
                      Download
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </VStack>
    </Box>
  );
};

export default UserBilling; 